var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useCallback } from 'react';
import { useUseCase } from "../../../hooks/useUseCase";
import { useTranslation } from "../../../hooks/useTranslation";
import { Dialog, DialogActions, DialogButton, DialogContent, DialogTitle, makeStyles } from "../../../index";
import { QrCodeCamera } from "./components/QrCodeCamera";
import { QrCodeResult } from "./components/QrCodeResult";
import { QrCodeReaderDisclaimer } from "./components/QrCodeReaderDisclaimer";
import { CloseQrCodeReaderDialogUseCase } from "./usecases/CloseQrCodeReaderDialogUseCase";
import { FindQrCodeUseCase } from "./usecases/FindQrCodeUseCase";
import { QrCodeReaderDialogState } from "./QrCodeReaderDialogState";
import { DisableCameraUseCase } from "./usecases/DisableCameraUseCase";
var useStyles = makeStyles(function () { return ({
    container: {
        flexGrow: 1,
        flexShrink: 1,
        flexBasis: 'auto',
        padding: 0,
    },
    main: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        overflow: 'auto',
    },
}); });
export var QrCodeReaderDialog = function (props) {
    var open = props.open, onClose = props.onClose, others = __rest(props, ["open", "onClose"]);
    var _a = useUseCase(new QrCodeReaderDialogState()), state = _a.state, usecase = _a.usecase;
    var classes = useStyles();
    var t = useTranslation().t;
    var handleClose = useCallback(function () {
        onClose === null || onClose === void 0 ? void 0 : onClose();
        usecase(new CloseQrCodeReaderDialogUseCase()).execute();
    }, [onClose, usecase]);
    var handleQrCodeFind = useCallback(function (result) {
        usecase(new FindQrCodeUseCase()).execute(result);
    }, [usecase]);
    var handleDisableCamera = useCallback(function () {
        usecase(new DisableCameraUseCase()).execute();
    }, [usecase]);
    return (React.createElement(Dialog, __assign({ open: open, fullScreen: true }, others),
        React.createElement(DialogTitle, null, t('QRコードを読み取る')),
        React.createElement(DialogContent, { className: classes.container },
            React.createElement("div", { className: classes.main }, state.result ? (React.createElement(QrCodeResult, { result: state.result })) : (React.createElement(QrCodeCamera, { onQrCodeFind: handleQrCodeFind, open: open, onCameraDisabled: handleDisableCamera })))),
        React.createElement(DialogActions, null,
            React.createElement(DialogButton, { onClick: handleClose, fill: true }, t('OK'))),
        !state.result && !state.cameraDisabled && React.createElement(QrCodeReaderDisclaimer, null)));
};
